var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-build',{attrs:{"form-name":"form-name","form-data":_vm.form,"form-rules":_vm.formRules,"form-columns-group":_vm.formColumnsGroup,"form-buttons":_vm.formButtons},on:{"update:formData":function($event){_vm.form=$event},"update:form-data":function($event){_vm.form=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039b92d9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/PayFinancingFangComponent.vue
// module id = null
// module chunks = 